import { Component } from '@angular/core';
import { AlertController, NavController, NavParams, ViewController } from 'ionic-angular';
import { FormGroup } from "@angular/forms";
import { MeasurementService } from "../../services/measurement.service";
import { Test300Service } from "../../services/testo300.service";
import { AppAvailability } from "@ionic-native/app-availability";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { ReportMeasurementPage } from "../report-measurement/report-measurement";

@Component({
  selector: 'page-report-measurement-get',
  templateUrl: 'report-measurement-get.html',
})
export class ReportMeasurementGetPage {

  form: FormGroup;
  page: ReportMeasurementPage;
  busy = -1;
  simulation = false;
  hasData = false;
  noDeviceFound = false;
  deviceName = '';
  deviceLastServiceDate = '';
  deviceSerial = '';
  isIOS = false;
  testo300Connecting = false;
  testo300Connected = false;

  timestamp:Date;
  values = {};
  descriptions = {};

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public testo300Service: Test300Service,
    public appAvailability: AppAvailability,
    public iab: InAppBrowser,
    public alertCtrl: AlertController,
    public measurementService: MeasurementService
  ) {
    this.form = navParams.get('form');
    this.page = navParams.get('page');
    this.isIOS = navParams.get('isIOS');
    if(this.isIOS){
      this.noDeviceFound = true;
      this.busy = 0;
    }
  }

  start(){
    if(this.isIOS){
      this.startMeasurement('ios');
    } else if(this.testo300Connected){
      this.startMeasurement('testo300');
    } else {
      this.startMeasurement();
    }
  }

  private startMeasurement(target_device?: string){
    this.busy = 1;
    this.simulation = false;
    this.hasData = false;
    this.noDeviceFound = false;
    this.measurementService.startMeasurement((data) => {
      console.log('Measurement data');
      console.log(data);
      if(data.timeStamp) this.timestamp = new Date(data.timeStamp);
      if(data.type.name == 'Simulation') this.simulation = true;
      if(data.device.name) this.deviceName = data.device.name;
      else if(data.device.deviceIdentifier) this.deviceName = data.device.deviceIdentifier;
      if(data.device.lastServiceDate) this.deviceLastServiceDate = data.device.lastServiceDate;
      if(data.device.serial) this.deviceSerial = data.device.serial;
      console.log(data.device);
      if(data.channels){
        for(let i = 0; i < data.channels.length; i++){
          let channel = data.channels[i];
          // @ts-ingnore
          if(channel.type.xmlid != null && channel.unit.xmlid != null && channel.values[0].value != null){
            this.hasData = true;
            let id = channel.type.xmlid + '_' + channel.unit.xmlid;
            this.values[id] = channel.values[0].value;
            this.descriptions[id] = channel.values[0].description;
          }
        }
      }
      console.log(this.values);
    }, target_device).then(() => {
      this.busy = 0;
      console.log('Measurement done');
    }).catch(() => {
      this.busy = 0;
      if(!this.hasData) this.noDeviceFound = true;
      console.log('No device found');
    })
  }

  stop(){
    this.measurementService.stopMeasurement();
  }

  submit(){
    let maxValidValue = 100000;
    let mapping = [
      ['CO_Dil_UNIT_PPM', 'co_ppm'],
      ['CO2_UNIT_PERCENT', 'co2_percent'],
      ['O2_UNIT_PERCENT', 'o2_percent'],
      ['T_Flue_UNIT_DEG_C', 't_flue_deg_c'],
      ['T_Air_UNIT_DEG_C', 't_air_deg_c'],
      ['Efficiency_UNIT_PERCENT', 'efficiency_hi_percent'],
      ['etaHS_UNIT_PERCENT', 'efficiency_hs_percent'],
      ['PStat_UNIT_MBAR', 'p_stat_mbar'],
      ['PDyn_UNIT_MBAR', 'p_dyn_mbar'],
      ['Pburn_UNIT_MBAR', 'p_burn_mbar'],
    ];
    for(let i = 0; i < mapping.length; i++){
      if(this.values[mapping[i][0]] != null && this.values[mapping[i][0]] <= maxValidValue){
        let value = Math.round(this.values[mapping[i][0]]*10)/10; // Round to 1 decimal
        this.form.get(mapping[i][1]).setValue(value);
      } else {
        this.form.get(mapping[i][1]).setValue('');
      }
    }
    // Set t_delta_deg_c
    if(this.values['T_Air_UNIT_DEG_C'] < maxValidValue && this.values['T_Flue_UNIT_DEG_C'] < maxValidValue){
      this.page.calculateDeltaT(this.form);
    }
    // Convert Ppm to MgKwh
    this.page.convertPpmToMgKwh(this.form);
    if(this.form.value.efficiency_hi_percent && !this.form.value.efficiency_hs_percent){
      this.page.convertEfficiencyHiToHs(this.form);
    } else if (this.form.value.efficiency_hs_percent && !this.form.value.efficiency_hi_percent) {
      this.page.convertEfficiencyHsToHi(this.form);
    }
    // Device
    if(this.deviceSerial){
      this.form.get('device_sn').setValue(this.deviceSerial);
    }
    if(this.deviceLastServiceDate){
      this.form.get('device_last_service_date').setValue(this.deviceLastServiceDate);
    }
    this.closeModal();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportMeasurementGetPage');
  }

  closeModal(){
    this.stop();
    if(this.testo300Connected){
      this.disconnectTesto300();
    }
    this.viewCtrl.dismiss();
  }

  connectTesto300(){
    this.busy = 2;
    this.testo300Service.connect().then((result) => {
      this.testo300Connected = true;
      this.start();
    }).catch((err) => {
      this.busy = -1;
      this.alertCtrl.create({
        title: 'Fout',
        message: 'Er kon geen verbinding worden gemaakt met uw Testo 300 rookgasmeter. Zorg dat de Wifi Hotsport van uw Testo 300 is ingeschakeld.',
        buttons: ['OK']
      }).present();
    });
  }

  disconnectTesto300(){
    this.testo300Service.disconnect().then(() => {
      this.testo300Connected = false;
    }).catch((err) => {
      console.error('Testo 300 disconnect error:' + JSON.stringify(err));
    });
  }

  openCombustionApp(){
    let id = 'testo.android.reader';
    this.appAvailability.check(id).then(() => {
      this.iab.create('android-app://testo.android.reader', '_system');
      this.noDeviceFound = true;
      this.busy = 0;
    }).catch((err) => {
      this.iab.create('https://play.google.com/store/apps/details?id=testo.android.reader', '_system');
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-measurement-get/report-measurement-get.ts